import React from 'react';
import CV from '../../assets/cv/cv.pdf';

export default function CTA() {
  return (
    <div className='cta'>
      <a href={CV} download className='btn download btn-animation'>Download CV</a>
      <a href='#contact' className='btn btn-primary btn-animation'>Let's Talk</a>
    </div>
  );
}
